import axios from 'axios';
import { API_URL } from 'utils/http';
import { SessionAccess } from 'types/user';

export const SESSION_ACCESS_PATH = '/me/access';

const isCurrentOrNotModified = (status: number) =>
  (status >= 200 && status < 300) || status === 304;

export async function getSessionAccess({
  version,
  fresh,
}: {
  version?: string;
  fresh?: boolean;
}) {
  const { status, data } = await axios.get<SessionAccess>(
    `${API_URL}${SESSION_ACCESS_PATH}`,
    {
      params: fresh ? { fresh: 1 } : undefined,
      headers: version ? { 'If-None-Match': `"${version}"` } : undefined,
      validateStatus: isCurrentOrNotModified,
    },
  );
  return status === 304 ? null : data;
}
